(function(){
  const qs=(s,c=document)=>c.querySelector(s); const qsa=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const money=(cents)=>{ try{ return new Intl.NumberFormat('ro-RO',{style:'currency',currency:'RON'}).format(cents/100).replace('RON','lei'); }catch(e){return (cents/100).toFixed(2)+' lei';} };
  const overlay=qs('[data-eo-overlay]'); const mobileMenu=qs('[data-mobile-menu]');
  const getCartDrawer=()=>qs('[data-cart-drawer]'); const getWishlistDrawer=()=>qs('[data-wishlist-drawer]');
  function openOverlay(){ overlay && overlay.classList.add('is-active'); }
  function closeOverlay(){ overlay && overlay.classList.remove('is-active'); }
  function openCart(){ const cartDrawer=getCartDrawer(); if(cartDrawer){cartDrawer.classList.add('is-open');cartDrawer.setAttribute('aria-hidden','false');openOverlay();} }
  function closeCart(){ const cartDrawer=getCartDrawer(); if(cartDrawer){cartDrawer.classList.remove('is-open');cartDrawer.setAttribute('aria-hidden','true');closeOverlay();} }
  function openMobile(){ if(mobileMenu){mobileMenu.hidden=false; requestAnimationFrame(()=>mobileMenu.classList.add('is-open')); openOverlay();} }
  function closeMobile(){ if(mobileMenu){mobileMenu.classList.remove('is-open'); setTimeout(()=>mobileMenu.hidden=true,260); closeOverlay();} }
  function openWishlist(){ const drawer=getWishlistDrawer(); if(drawer){ renderWishlistDrawer(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); openOverlay(); } }
  function closeWishlist(){ const drawer=getWishlistDrawer(); if(drawer){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); closeOverlay(); } }
  document.addEventListener('click',function(e){ if(e.target.closest('[data-cart-open]')){ e.preventDefault(); openCart(); } if(e.target.closest('[data-cart-close]')){ e.preventDefault(); closeCart(); } if(e.target.closest('[data-wishlist-open]')){ e.preventDefault(); openWishlist(); } if(e.target.closest('[data-wishlist-close]')){ e.preventDefault(); closeWishlist(); } });
  qsa('[data-mobile-menu-toggle]').forEach(b=>b.addEventListener('click',openMobile)); qsa('[data-mobile-menu-close]').forEach(b=>b.addEventListener('click',closeMobile));
  overlay && overlay.addEventListener('click',()=>{closeCart();closeMobile();closeWishlist();});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeCart();closeMobile();closeWishlist();}});

  function renderCart(cart){
    qsa('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    qsa('[data-cart-total]').forEach(el=>el.textContent=money(cart.total_price));
  }
  function escapeHtml(s){return String(s||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));}
  function refreshCartDrawer(){
    const current=getCartDrawer();
    if(!current) return Promise.resolve();
    const wasOpen=current.classList.contains('is-open');
    return fetch('/cart?section_id=cart-drawer-clean',{headers:{'Accept':'text/html'}})
      .then(r=>r.text())
      .then(html=>{
        const tpl=document.createElement('div');
        tpl.innerHTML=html.trim();
        const fresh=tpl.querySelector('[data-cart-drawer]');
        if(fresh){
          current.replaceWith(fresh);
          if(wasOpen){
            fresh.classList.add('is-open');
            fresh.setAttribute('aria-hidden','false');
            openOverlay();
          }
        }
      })
      .catch(()=>{});
  }
  function fetchCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json()).then(cart=>{renderCart(cart); return refreshCartDrawer().then(()=>cart);});}
  document.addEventListener('submit',function(e){const form=e.target.closest('[data-ajax-cart-form], form.eo-product-form'); if(!form) return; e.preventDefault(); const btn=form.querySelector('button[type="submit"]'); if(btn){btn.disabled=true;btn.dataset.oldText=btn.textContent;} fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}}).then(r=>{if(!r.ok) throw new Error('cart'); return r.json();}).then(fetchCart).then(openCart).catch(()=>form.submit()).finally(()=>{if(btn){btn.disabled=false;if(btn.dataset.oldText)btn.textContent=btn.dataset.oldText;}});});
  document.addEventListener('click',function(e){const remove=e.target.closest('[data-cart-remove]'); if(remove){e.preventDefault(); const line=remove.getAttribute('data-cart-remove'); fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(line),quantity:0})}).then(r=>r.json()).then(cart=>{renderCart(cart); return refreshCartDrawer();});}}
  );
  document.addEventListener('click',function(e){const minus=e.target.closest('[data-qty-minus]'), plus=e.target.closest('[data-qty-plus]'); if(!minus&&!plus) return; const box=e.target.closest('.eo-qty'); const input=box&&box.querySelector('input'); if(!input) return; const min=Number(input.min||0); let val=Number(input.value||0)+(plus?1:-1); if(val<min) val=min; input.value=val; input.dispatchEvent(new Event('change',{bubbles:true}));});
  const WKEY='eoWishlist'; const getW=()=>{try{return JSON.parse(localStorage.getItem(WKEY)||'[]')}catch(e){return[]}}; const setW=(w)=>{localStorage.setItem(WKEY,JSON.stringify(w));updateW();renderWishlistDrawer();};
  function updateW(){const w=getW(); qsa('[data-wishlist-count]').forEach(el=>el.textContent=w.length); qsa('[data-wishlist-toggle]').forEach(btn=>{const h=btn.dataset.productHandle; const active=!!(h&&w.some(x=>x.handle===h)); btn.classList.toggle('is-active',active); btn.setAttribute('aria-pressed',active?'true':'false'); const label=btn.querySelector('[data-wishlist-label]'); if(label){ label.textContent=active?(btn.dataset.addedText||'Adăugat în Wishlist'):(btn.dataset.addText||'Adaugă în Wishlist'); } });}
  function renderWishlistDrawer(){
    const body=qs('[data-wishlist-body]'); if(!body) return;
    const w=getW();
    if(!w.length){ body.innerHTML='<div class="eo-wishlist-empty"><strong>Lista de dorințe este goală.</strong><br><span>Adaugă produse folosind iconul inimă de pe carduri.</span></div>'; return; }
    body.innerHTML='<div class="eo-wishlist-list">'+w.map(item=>{
      const img=item.image?'<img src="'+escapeHtml(item.image)+'" alt="'+escapeHtml(item.title||'Produs')+'">':'<img src="//cdn.shopify.com/s/images/admin/no-image-large.gif" alt="">';
      return '<div class="eo-wishlist-item">'+img+'<div><a class="eo-wishlist-item-title" href="'+escapeHtml(item.url||'#')+'">'+escapeHtml(item.title||'Produs')+'</a>'+(item.price?'<span class="eo-wishlist-item-price">'+escapeHtml(item.price)+'</span>':'')+'</div><button type="button" class="eo-wishlist-remove" data-wishlist-remove="'+escapeHtml(item.handle||'')+'" aria-label="Șterge produsul">×</button></div>';
    }).join('')+'</div><div class="eo-wishlist-actions"><button type="button" class="eo-wishlist-continue" data-wishlist-close>Continuă cumpărăturile</button></div>';
  }
  document.addEventListener('click',function(e){const btn=e.target.closest('[data-wishlist-toggle]'); if(!btn) return; e.preventDefault(); const handle=btn.dataset.productHandle||btn.dataset.title||location.pathname; let w=getW(); if(w.some(x=>x.handle===handle)){w=w.filter(x=>x.handle!==handle);}else{w.push({handle,title:btn.dataset.title||'Produs',url:btn.dataset.url||location.href,image:btn.dataset.image||'',price:btn.dataset.price||''});} setW(w);});
  document.addEventListener('click',function(e){const btn=e.target.closest('[data-wishlist-remove]'); if(!btn) return; e.preventDefault(); const handle=btn.getAttribute('data-wishlist-remove'); setW(getW().filter(x=>x.handle!==handle));});

  function setupPredictiveSearch(){
    qsa('.eo-search').forEach(form=>{
      const input=form.querySelector('input[name="q"]'); if(!input || form.dataset.predictiveReady) return; form.dataset.predictiveReady='true';
      const panel=document.createElement('div'); panel.className='eo-predictive-search'; panel.setAttribute('role','listbox'); form.appendChild(panel);
      let timer=null; let controller=null;
      function close(){panel.classList.remove('is-open'); panel.innerHTML='';}
      function productImage(p){ return (p.image && (p.image.url || p.image)) || (p.featured_image && (p.featured_image.url || p.featured_image)) || ''; }
      function productPrice(p){
        if(p.price) return p.price;
        if(p.price_min) return money(Number(p.price_min));
        if(p.variants && p.variants[0] && p.variants[0].price) return money(Number(p.variants[0].price));
        return '';
      }
      function render(products, term){
        if(!term){close(); return;}
        if(!products.length){ panel.innerHTML='<div class="eo-predictive-empty">Nu am găsit produse pentru „'+escapeHtml(term)+'”.</div>'; panel.classList.add('is-open'); return; }
        panel.innerHTML='<div class="eo-predictive-head"><strong>Produse găsite</strong><span>'+products.length+' rezultate</span></div><div class="eo-predictive-list">'+products.slice(0,4).map(p=>{
          const img=productImage(p); const title=p.title||'Produs'; const url=p.url||'#'; const price=productPrice(p);
          return '<a class="eo-predictive-item" href="'+escapeHtml(url)+'">'+(img?'<img class="eo-predictive-img" src="'+escapeHtml(img)+'" alt="'+escapeHtml(title)+'">':'<span class="eo-predictive-img"></span>')+'<span class="eo-predictive-title">'+escapeHtml(title)+'</span>'+(price?'<span class="eo-predictive-price">'+escapeHtml(price)+'</span>':'')+'</a>';
        }).join('')+'</div><a class="eo-predictive-all" href="/search?q='+encodeURIComponent(term)+'&type=product">Vezi toate rezultatele</a>';
        panel.classList.add('is-open');
      }
      function search(){
        const term=input.value.trim();
        if(term.length<2){close(); return;}
        panel.innerHTML='<div class="eo-predictive-loading">Se caută produse...</div>'; panel.classList.add('is-open');
        if(controller) controller.abort(); controller=new AbortController();
        const url='/search/suggest.json?q='+encodeURIComponent(term)+'&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';
        fetch(url,{headers:{'Accept':'application/json'},signal:controller.signal})
          .then(r=>r.ok?r.json():Promise.reject())
          .then(data=>render(((data.resources||{}).results||{}).products||[],term))
          .catch(err=>{ if(err && err.name==='AbortError') return; close(); });
      }
      input.addEventListener('input',()=>{ clearTimeout(timer); timer=setTimeout(search,180); });
      input.addEventListener('focus',()=>{ if(input.value.trim().length>=2) search(); });
      document.addEventListener('click',e=>{ if(!form.contains(e.target)) close(); });
      input.addEventListener('keydown',e=>{ if(e.key==='Escape') close(); });
    });
  }

  const discountBtn=qs('[data-discount-apply]'); if(discountBtn){discountBtn.addEventListener('click',()=>{const code=qs('#discount-code')?.value.trim(); if(code) location.href='/discount/'+encodeURIComponent(code)+'?redirect=/cart';});}
  updateW(); renderWishlistDrawer(); setupPredictiveSearch();
})();

(function(){
  const qs=(s,c=document)=>c.querySelector(s); const qsa=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const sidebar=qs('[data-filter-sidebar]'); const overlay=qs('[data-filter-overlay]');
  function openFilter(){ if(!sidebar) return; sidebar.classList.add('is-open'); overlay&&overlay.classList.add('is-active'); document.documentElement.style.overflow='hidden'; }
  function closeFilter(){ if(!sidebar) return; sidebar.classList.remove('is-open'); overlay&&overlay.classList.remove('is-active'); document.documentElement.style.overflow=''; }
  qsa('[data-filter-open]').forEach(btn=>btn.addEventListener('click',openFilter));
  qsa('[data-filter-close]').forEach(btn=>btn.addEventListener('click',closeFilter));
  overlay&&overlay.addEventListener('click',closeFilter);
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeFilter(); });

  document.addEventListener('click',function(e){
    const thumb=e.target.closest('[data-product-thumb]');
    if(!thumb) return;
    const src=thumb.getAttribute('data-product-thumb');
    const wrap=thumb.closest('.eo-gallery');
    const img=wrap&&wrap.querySelector('[data-main-product-image] img');
    const opener=wrap&&wrap.querySelector('[data-gallery-open]');
    const idx=Number(thumb.getAttribute('data-gallery-index')||0);
    if(src&&img){
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src=src;
      qsa('[data-product-thumb]',wrap).forEach(t=>t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
    if(opener) opener.setAttribute('data-gallery-index', String(idx));
  });
})();

(function(){
  const qs=(s,c=document)=>c.querySelector(s);
  const qsa=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const lightbox=qs('[data-product-lightbox]');
  const gallery=qs('[data-product-gallery]');
  if(!lightbox) return;

  const images=qsa('[data-lightbox-image]', lightbox);
  const thumbs=qsa('[data-lightbox-thumb]', lightbox);
  const mainOpener=qs('[data-gallery-open]');
  let current=0;
  let startX=0;
  let startY=0;
  let isPointerDown=false;

  function getActiveThumbIndex(){
    const active=gallery && qs('[data-product-thumb].is-active', gallery);
    return active ? Number(active.getAttribute('data-gallery-index')||0) : 0;
  }

  function syncPageGallery(index){
    if(!gallery) return;
    const pageThumb=qsa('[data-product-thumb]', gallery).find(t=>Number(t.getAttribute('data-gallery-index')||0)===index);
    if(!pageThumb) return;
    const src=pageThumb.getAttribute('data-product-thumb');
    const img=gallery.querySelector('[data-main-product-image] img');
    if(src && img){
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src=src;
    }
    qsa('[data-product-thumb]',gallery).forEach(t=>t.classList.remove('is-active'));
    pageThumb.classList.add('is-active');
    if(mainOpener) mainOpener.setAttribute('data-gallery-index', String(index));
  }

  function show(i){
    if(!images.length) return;
    current=(Number(i)+images.length)%images.length;
    images.forEach((img,idx)=>img.classList.toggle('is-active', idx===current));
    thumbs.forEach((thumb,idx)=>thumb.classList.toggle('is-active', idx===current));
    if(mainOpener) mainOpener.setAttribute('data-gallery-index', String(current));
    syncPageGallery(current);
  }

  function open(i){
    const index=Number.isFinite(Number(i)) ? Number(i) : getActiveThumbIndex();
    show(index);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
  }

  function close(){
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';
  }

  document.addEventListener('click',function(e){
    const opener=e.target.closest('[data-gallery-open]');
    if(opener){ e.preventDefault(); open(opener.getAttribute('data-gallery-index')); return; }
    const thumb=e.target.closest('[data-lightbox-thumb]');
    if(thumb){ e.preventDefault(); show(Number(thumb.getAttribute('data-gallery-index')||0)); return; }
    const closeBtn=e.target.closest('[data-lightbox-close]');
    if(closeBtn){ e.preventDefault(); close(); return; }
    const prev=e.target.closest('[data-lightbox-prev]');
    if(prev){ e.preventDefault(); show(current-1); return; }
    const next=e.target.closest('[data-lightbox-next]');
    if(next){ e.preventDefault(); show(current+1); return; }
    if(e.target===lightbox){ close(); }
  });

  document.addEventListener('keydown',function(e){
    if(!lightbox.classList.contains('is-open')) return;
    if(e.key==='Escape') close();
    if(e.key==='ArrowLeft') show(current-1);
    if(e.key==='ArrowRight') show(current+1);
  });

  lightbox.addEventListener('touchstart',function(e){
    if(!e.touches || !e.touches.length) return;
    startX=e.touches[0].clientX;
    startY=e.touches[0].clientY;
  },{passive:true});

  lightbox.addEventListener('touchend',function(e){
    if(!e.changedTouches || !e.changedTouches.length) return;
    const dx=e.changedTouches[0].clientX-startX;
    const dy=e.changedTouches[0].clientY-startY;
    if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)){
      dx<0 ? show(current+1) : show(current-1);
    }
  },{passive:true});

  lightbox.addEventListener('pointerdown',function(e){
    if(e.pointerType==='touch') return;
    isPointerDown=true;
    startX=e.clientX;
    startY=e.clientY;
  });

  lightbox.addEventListener('pointerup',function(e){
    if(!isPointerDown || e.pointerType==='touch') return;
    isPointerDown=false;
    const dx=e.clientX-startX;
    const dy=e.clientY-startY;
    if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)){
      dx<0 ? show(current+1) : show(current-1);
    }
  });
})();
(function(){
  const sliders = Array.from(document.querySelectorAll('[data-eo-hero-slider]'));
  sliders.forEach(slider => {
    const slides = Array.from(slider.querySelectorAll('[data-eo-hero-slide]'));
    if (slides.length <= 1) return;
    const dots = Array.from(slider.querySelectorAll('[data-eo-hero-dot]'));
    const prev = slider.querySelector('[data-eo-hero-prev]');
    const next = slider.querySelector('[data-eo-hero-next]');
    const autoplay = slider.getAttribute('data-autoplay') === 'true';
    const interval = Math.max(Number(slider.getAttribute('data-interval') || 5000), 3000);
    let current = slides.findIndex(slide => slide.classList.contains('is-active'));
    if (current < 0) current = 0;
    let timer = null;

    function go(index){
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    }

    function stop(){ if(timer) { clearInterval(timer); timer = null; } }
    function start(){ if(!autoplay) return; stop(); timer = setInterval(() => go(current + 1), interval); }

    prev && prev.addEventListener('click', () => { go(current - 1); start(); });
    next && next.addEventListener('click', () => { go(current + 1); start(); });
    dots.forEach(dot => dot.addEventListener('click', () => { go(Number(dot.dataset.eoHeroDot || 0)); start(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    go(current);
    start();
  });
})();


/* v24: randomize recently viewed products on /collections/all */
(function(){
  function shuffle(nodes){
    for(var i=nodes.length-1;i>0;i--){
      var j=Math.floor(Math.random()*(i+1));
      var tmp=nodes[i]; nodes[i]=nodes[j]; nodes[j]=tmp;
    }
    return nodes;
  }
  document.querySelectorAll('[data-random-products]').forEach(function(grid){
    var limit=Math.max(Number(grid.getAttribute('data-random-limit')||5),1);
    var cards=Array.from(grid.children).filter(function(el){return el.classList&&el.classList.contains('eo-product-card');});
    if(!cards.length) return;
    shuffle(cards).forEach(function(card,index){
      grid.appendChild(card);
      card.style.display=index<limit?'':'none';
    });
  });
})();



/* =========================================================
   VARIANT IMAGE -> MAIN PRODUCT IMAGE
   ========================================================= */

(function () {
  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-variant-select]');

    if (!select) return;

    const selectedOption = select.options[select.selectedIndex];

    if (!selectedOption) return;

    const variantImage = selectedOption.getAttribute('data-variant-image');
    const variantMediaId = selectedOption.getAttribute('data-variant-media-id');

    if (!variantImage) return;

    const productSection = select.closest('.eo-product-main--v4') || document;
    const gallery = productSection.querySelector('[data-product-gallery]');

    if (!gallery) return;

    const mainImage = gallery.querySelector('[data-main-product-image] img');
    const galleryOpener = gallery.querySelector('[data-gallery-open]');

    if (mainImage) {
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = variantImage;
    }

    const thumbs = Array.from(
      gallery.querySelectorAll('[data-product-thumb]')
    );

    thumbs.forEach(function (thumb) {
      thumb.classList.remove('is-active');
    });

    if (variantMediaId) {
      const matchingThumb = thumbs.find(function (thumb) {
        return thumb.getAttribute('data-media-id') === variantMediaId;
      });

      if (matchingThumb) {
        matchingThumb.classList.add('is-active');

        const galleryIndex =
          matchingThumb.getAttribute('data-gallery-index') || '0';

        if (galleryOpener) {
          galleryOpener.setAttribute(
            'data-gallery-index',
            galleryIndex
          );
        }

        /* Pe mobile aducem thumbnail-ul selectat în zona vizibilă */
        matchingThumb.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }
  });
})();